import { useMemo } from 'react';
import {
    type DisableAdsAnalytics,
    tariffBuyWhenDisableAdsModalAnalytics,
} from 'reactApp/appHelpers/featuresHelpers/features/disableAdsScreen';

export function useDisableAdsAnalytics(
    analyticsFromQuery?: string,
    fallbacks: DisableAdsAnalytics = {}
): {
    name?: string | undefined;
    paySource: string;
    actionClick?: string;
    actionShow?: string;
    actionSwitch?: string;
} {
    return useMemo(() => {
        if (analyticsFromQuery && tariffBuyWhenDisableAdsModalAnalytics?.hasOwnProperty(analyticsFromQuery)) {
            return { paySource: 'modal_noads_tariff', ...tariffBuyWhenDisableAdsModalAnalytics[analyticsFromQuery] };
        }

        const cleanFallbacks: DisableAdsAnalytics = Object.fromEntries(
            Object.entries(fallbacks).filter(([_, value]) => value !== undefined)
        );

        return {
            paySource: 'modal_noads_tariff',
            actionClick: 'modal-noads-click',
            actionShow: 'modal-noads-show',
            actionSwitch: 'modal-noads-switch',
            ...cleanFallbacks,
        };
    }, [analyticsFromQuery]);
}
